import React, { useMemo } from 'react'
import { Button, LinkInline } from '@dasa-health/alma-react'
import { useAppContext } from '@nsw-paginas-deslogadas/store/useAppContext'
import { Images, BrandMapping } from '@nsw-paginas-deslogadas/assets'
import * as S from './styles'

const FoldAboutNavV2: React.FC = () => {
    const { CellPhoneIllustrationV2 } = Images
    const { brand: brand_, product } = useAppContext()
    const brand = BrandMapping[brand_.mappingId]

    const productLabel = useMemo(() => `Agendar ${product.category?.id === 4 ? 'vacina' : 'exame'}`, [product])

    const slashLength = window.location.pathname.match(/\//g)?.length

    const dataAtributtes = (dataText: string) => ({
        'data-item-position': 'O que é Nav?',
        'data-current-service': slashLength && slashLength > 2 ? 'Página de Produto da Marca' : 'Página da Marca',
        'data-item-text': dataText,
    })

    return (
        <S.Container data-testid="about-testID">
            <S.Content>
                <S.TextBox>
                    <S.Title>O que é o Nav Dasa?</S.Title>
                    <S.Paragraph>
                        Eu sou o Nav Dasa, seu assistente de saúde digital pra toda vida. Comigo, você pode conversar com um médico
                        quando e onde estiver com Consulta Online 24h, agendar consultas com especialistas, marcar seus exames e
                        acompanhar todo o seu histórico de saúde. <strong>Simples, fácil e descomplicado.</strong>
                    </S.Paragraph>
                </S.TextBox>

                <S.ButtonsBox>
                    {product?.category && (
                        <LinkInline
                            href={product.navigateTo}
                            sx={{ textDecoration: 'none' }}
                            target="_self"
                            {...dataAtributtes(productLabel)}
                        >
                            <Button data-testid="btn-vaccines">{productLabel}</Button>
                        </LinkInline>
                    )}

                    {!product?.category && (
                        <>
                            {brand.vaccine && (
                                <LinkInline
                                    href={brand.buttons.about.vaccines}
                                    sx={{ textDecoration: 'none' }}
                                    target="_self"
                                    {...dataAtributtes('Agendar vacinas')}
                                >
                                    <Button data-testid="btn-vaccines">Agendar vacina</Button>
                                </LinkInline>
                            )}
                            <LinkInline
                                href={brand.buttons.about.exams}
                                sx={{ textDecoration: 'none' }}
                                target="_self"
                                {...dataAtributtes('Agendar exames')}
                            >
                                <Button data-testid="btn-exams">Agendar exame</Button>
                            </LinkInline>
                        </>
                    )}
                </S.ButtonsBox>
            </S.Content>
            <S.Img alt={CellPhoneIllustrationV2.alt} src={CellPhoneIllustrationV2.src} />
        </S.Container>
    )
}
export default FoldAboutNavV2
